import React from 'react'
import PlayStore from '../../static/icons/ic-play-store.webp'
import AppsStore from '../../static/icons/ic-apps-store.webp'
import { DownloadImageLink } from './index.styles'

const ImageDownloadLink = () => {
  return (
    <>
      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <b>Klik Untuk Download Aplikasi</b>
      </div>
      <DownloadImageLink>
        <a
          href="https://play.google.com/store/apps/details?id=halo.jasa.startup"
          target="_blank"
          className="smaller-hover android-store"
          rel="noopener noreferrer"
        >
          <img src={PlayStore} alt="halojasa/play-store" />
        </a>
        <a
          target="_blank"
          href="https://apps.apple.com/app/apple-store/id1492671277?pt=119003762&ct=website%20halo%20jasa&mt=8"
          rel="noopener noreferrer"
          className="smaller-hover ios-store"
        >
          <img src={AppsStore} alt="halojasa/app-store" />
        </a>
      </DownloadImageLink>
    </>
  )
}

export default ImageDownloadLink
